import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    validation: { type: String, default: "" },
    count: { type: Number, default: 0 },
    style: { type: String, default: "drop" },
    scope: String,
  }

  connect() {
    this.ensureStyles()
    this.flash()
  }

  get storageKey() {
    return `showcase-validation-count-${this.scopeValue}`
  }

  get storedCount() {
    const stored = localStorage.getItem(this.storageKey)
    return stored ? parseInt(stored, 10) : 0
  }

  set storedCount(val) {
    localStorage.setItem(this.storageKey, val)
  }

  ensureStyles() {
    if (document.getElementById("validation-flash-styles")) return

    const style = document.createElement("style")
    style.id = "validation-flash-styles"
    style.textContent = `
      @keyframes validation-fall {
        0% {
          transform: translateY(0) rotate(0deg);
          opacity: 1;
        }
        100% {
          transform: translateY(110vh) rotate(var(--rotation));
          opacity: 0;
        }
      }
      @keyframes validation-splode {
        0% {
          transform: scale(0.5);
          opacity: 1;
        }
        100% {
          transform: scale(3);
          opacity: 0;
        }
      }
    `
    document.head.appendChild(style)
  }

  flash() {
    const count = this.countValue - this.storedCount
    const createParticle = this.styleValue === "splode"
      ? () => this.createSplode()
      : () => this.createDrop()
    const multiplier = Math.floor(Math.random() * 7) + 3

    for (let i = 0; i < count * multiplier; i++) {
      setTimeout(createParticle, i * 100)
    }

    this.storedCount = this.storedCount + count
  }

  createDrop() {
    const drop = document.createElement("div")
    const rotation = 360 + Math.random() * 720
    const duration = 2 + Math.random() * 3

    drop.textContent = this.validationValue
    drop.style.cssText = `
      position: fixed;
      top: -50px;
      left: ${Math.random() * 100}vw;
      font-size: ${20 + Math.random() * 30}px;
      pointer-events: none;
      z-index: 9999;
      --rotation: ${rotation}deg;
      animation: validation-fall ${duration}s linear forwards;
    `

    document.body.appendChild(drop)
    drop.addEventListener("animationend", () => drop.remove())
  }

  createSplode() {
    const splode = document.createElement("div")
    const duration = 1 + Math.random() * 1.5

    splode.textContent = this.validationValue
    splode.style.cssText = `
      position: fixed;
      top: ${10 + Math.random() * 80}vh;
      left: ${10 + Math.random() * 80}vw;
      font-size: ${20 + Math.random() * 30}px;
      pointer-events: none;
      z-index: 9999;
      animation: validation-splode ${duration}s ease-out forwards;
    `

    document.body.appendChild(splode)
    splode.addEventListener("animationend", () => splode.remove())
  }
}
